import { absoluteUrl } from "@/lib/seo";
import { displayName, type Testimonial } from "@/lib/testimonials";

/**
 * Strukturerad data för omdömessidan. Bygger enbart på riktiga, publicerade
 * omdömen – demodata får aldrig ingå i betyg mot sökmotorer.
 */
export function reviewsJsonLd(reviews: Testimonial[], average: number, count: number) {
  if (!count) return [];
  return [
    {
      type: "application/ld+json",
      children: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "EducationalOrganization",
        name: "Swedish International School",
        url: absoluteUrl("/"),
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: average,
          reviewCount: count,
          bestRating: 5,
          worstRating: 1,
        },
        review: reviews.slice(0, 12).map((r) => ({
          "@type": "Review",
          reviewBody: r.quote,
          datePublished: (r.publishedAt ?? r.createdAt ?? "").slice(0, 10) || undefined,
          author: { "@type": "Person", name: displayName(r) || "Anonym" },
          reviewRating: { "@type": "Rating", ratingValue: r.rating, bestRating: 5, worstRating: 1 },
        })),
      }),
    },
  ];
}
